import React from 'react';

export default function WholesalerSelect({ state, wholesaler, wholesalers, onChange, accountNumber }) {
  return (
    <>
      <div className="form-group">
        <label htmlFor="wholesaler">
          Wholesaler <span className="required-asterisk">*</span>
        </label>
        <select
          id="wholesaler"
          name="wholesaler"
          value={wholesaler}
          onChange={onChange}
          required
          disabled={!state}
          className="form-input"
        >
          <option value="">
            {state ? '-- Please select your wholesaler --' : 'Select a state first'}
          </option>
          {wholesalers.map((w) => (
            <option key={w} value={w}>{w}</option>
          ))}
        </select>
        <small className="field-hint">
          {state
            ? 'Choose the wholesaler you purchase tobacco products from'
            : 'You must select a state above before choosing a wholesaler'}
        </small>
      </div>

      <div className="form-group">
        <label htmlFor="wholesalerAccountNumber">
          Wholesaler Account Number <span className="required-asterisk">*</span>
        </label>
        <input
          id="wholesalerAccountNumber"
          type="text"
          name="wholesalerAccountNumber"
          value={accountNumber}
          onChange={onChange}
          required
          className="form-input"
          placeholder="xxxxxxxxxx"
        />
        <small className="field-hint">Put "000" if you do not have an account number</small>
      </div>
    </>
  );
}
